import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { httpReauest } from '../utils/httpRequest';

export function useRouteInfo() {
  const [routeInfo, setRouteInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation()

  useEffect(() => {
    const fetchRouteInfo = async () => {
      try {
        setLoading(true);
        const res = await httpReauest("GET", "/routes/info?path=" + location.pathname, {}, {});
        setRouteInfo(res.data.data);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchRouteInfo();
  }, [location.pathname]);

  return { metaData : routeInfo, loading, error };
}